import { render, staticRenderFns } from "./ReservationSettingTab.vue?vue&type=template&id=4ed0ded0&scoped=true&lang=pug"
import script from "./ReservationSettingTab.vue?vue&type=script&lang=ts"
export * from "./ReservationSettingTab.vue?vue&type=script&lang=ts"
import style0 from "./ReservationSettingTab.vue?vue&type=style&index=0&id=4ed0ded0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed0ded0",
  null
  
)

export default component.exports